import GraphqlError from '~/components/GraphqlError';
import wrapError from '~/components/JavascriptError/JavascriptErrorHandler';
import LoadingArea from '~/components/LoadingArea';
import MissingPage from '~/components/MissingPage';
import { useFancyQuery } from '~/lib/graphql';

import CompanyDrawerDetails from '../Show/CompaniesDrawerDetails';
import query from './query.graphql';

type CompanyFromDomainProps = {
  domain: string;
};

const CompanyFromDomain = ({ domain }: CompanyFromDomainProps) => {
  const { data, loading, error, refetch } = useFancyQuery(query, {
    // @ts-ignore
    variables: { companiesSearchQuery: domain },
    returnPartialData: true,
  });

  if (error) {
    return (
      <div className="x-sidebar">
        <GraphqlError error={error} refetch={refetch} />;
      </div>
    );
  }

  if (loading) {
    return <LoadingArea className="x-sidebar" loading />;
  }

  if (!data?.companies?.edges?.[0]?.node?.id) {
    return <MissingPage className="x-sidebar" />;
  }

  return <CompanyDrawerDetails id={data.companies.edges[0].node.id} />;
};

export default wrapError(CompanyFromDomain);
